import { atomWithStorage } from "jotai/utils";
import { NotificationItem } from "./generatedApi/notificationManagerApi";
import { MoodCategory } from "./generatedApi/adminSearchEngineApi";

export const callbackDraftPathAtom = atomWithStorage<string>("callbackDraftPath", "");
export const callbackDraftPageAtom = atomWithStorage<string>("callbackDraftPage", "");
export const callbackPublicPathAtom = atomWithStorage<string>("callbackPublicPath", "");
export const callbackPublicPageAtom = atomWithStorage<string>("callbackPublicPage", "");
export const callbackTabAtom = atomWithStorage<string>("callbackTab", "");

export const editingNotificationItemAtom = atomWithStorage<NotificationItem | null>(
  "notificationItem",
  null
);

type SpotItemAtomType = {
  id: string;
  jsonStrinify: string;
};
export const editingSpotItemAtom = atomWithStorage<SpotItemAtomType | null>("spotItem", null);

type StateObjectType = {
  userId: string;
  postalCode: string;
  queryPrefecture: string[];
  queryMoodCategory: MoodCategory[];
  queryGenre: string[];
  querySubgenre: string[];
  queryScoreFunction: string;
  querySkipSavedSpots: boolean;
  recommendMode: "default" | "experiment";
};
const initialState: StateObjectType = {
  // デフォルトを管理者用のID("refloop_1705403019672")に設定
  userId: "refloop_1705403019672",
  postalCode: "",
  queryPrefecture: [],
  queryMoodCategory: [],
  queryGenre: [],
  querySubgenre: [],
  queryScoreFunction: "",
  querySkipSavedSpots: false,
  recommendMode: "default"
};
export const queryFormAtom = atomWithStorage<StateObjectType>(
  "recommendationQueryForm",
  initialState
);
